import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconForkCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconForkCode"><Path d="M6 3C4.34315 3 3 4.34315 3 6C3 7.39788 3.95608 8.57245 5.25 8.90549V12.75H11.25V15.0945C9.95608 15.4275 9 16.6021 9 18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18C15 16.6021 14.0439 15.4275 12.75 15.0945V12.75H18.75V8.90549C20.0439 8.57245 21 7.39788 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.39788 15.9561 8.57245 17.25 8.90549V11.25H6.75V8.90549C8.04392 8.57245 9 7.39788 9 6C9 4.34315 7.65685 3 6 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconForkCode;
